export default function init() {
  const roots = document.querySelectorAll('.menu__megamenu__columns');

  [...roots].forEach((root) => {
    const secondLevelLinks = root.querySelectorAll('[data-level="2"] > a');
    const thirdLevelLinks = root.querySelectorAll('[data-level="3"] > a');
    const thirdLevelColumns = root.querySelectorAll('.column[data-level="3"]');
    const fourthLevelColumns = root.querySelectorAll('.column[data-level="4"]');

    const setFourthLevelColumn = (el) => {
      if (el === null) {
        [...fourthLevelColumns].forEach((item) => { item.setAttribute('aria-hidden', true); });
      }

      if (el) {
        el.setAttribute('aria-hidden', false);
      }
    };

    const setThirdLevelColumn = (el) => {
      if (el === null) {
        [...thirdLevelColumns].forEach((item) => { item.setAttribute('aria-hidden', true); });
      }

      if (el) {
        el.setAttribute('aria-hidden', false);
        setFourthLevelColumn(null);
      }
    };

    const handleSecondLevelInteraction = (link) => {
      [...secondLevelLinks].forEach((i) => i.setAttribute('data-active', false));
      link.setAttribute('data-active', true);

      const target = root.querySelector(`[data-level="3"][data-id="${link.dataset.targetId}"]`);
      setThirdLevelColumn(target);
    };

    const handleThirdLevelInteraction = (link) => {
      [...thirdLevelLinks].forEach((i) => i.setAttribute('data-active', false));
      link.setAttribute('data-active', true);

      const target = root.querySelector(`[data-level="4"][data-id="${link.dataset.targetId}"]`);
      setFourthLevelColumn(target);
    };

    [...secondLevelLinks].forEach((link) => {
      link.addEventListener('mouseover', () => { handleSecondLevelInteraction(link); });
      link.addEventListener('focus', () => { handleSecondLevelInteraction(link); });
    });

    [...thirdLevelLinks].forEach((link) => {
      link.addEventListener('mouseover', () => { handleThirdLevelInteraction(link); });
      link.addEventListener('focus', () => { handleThirdLevelInteraction(link); });
    });
  });
}
